export default "/images/6a46c9ea7e9a75fad78a8cd3abccdfca.png";